import { FC, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDebouncedValue } from 'rooks';
import Input from 'src/components/0100_input';

interface IProps {
  fetching: boolean;
  onChange: (query: string) => void;
}

const Search: FC<IProps> = ({ fetching, onChange }) => {
  const { register, watch } = useForm({ defaultValues: { query: '' } });
  const { query } = watch();
  const [debouncedQuery] = useDebouncedValue(query, 100);

  useEffect(() => {
    onChange(debouncedQuery);
  }, [debouncedQuery, onChange]);

  return (
    <Input
      fullWidth
      placeholder="Search Items..."
      isFetching={fetching}
      {...register('query')}
    />
  );
};

export default Search;
